import {
  RECEIVE_TRAIN_POSITION,
  RECEIVE_JR_TRAIN_POSITION,
  RECEIVE_TOKYU_TRAIN_POSITION,
  RECEIVE_SHINYOKOHAMA_TRAIN_INFO,
  RECEIVE_TRAIN_DETAIL,
  RECEIVE_JR_TRAIN_DETAIL,
  CLOSE_TRAIN_MODAL,
  CLOSE_TRANSFER_MODAL,
  OPEN_TRAIN_SELECT_MODAL,
  CLOSE_TRAIN_SELECT_MODAL,
} from '../actions'

import { convertSotetsuToJr } from '../utils/TrainNumber'
import { extractTokyuTrains, extractJrTrains } from '../utils/TrainExtractor'
import MasterData from '../data/MasterData'

const merge = require('deepmerge')

const initialState = {
  trains: [],
  updatedAt: Date.now(),
  jrLocationUpdatedAt: null,
  jrDetailUpdatedAt: null,
  showingTrain: null, // TODO: 名前と初期値が良くない気がする
  selectingTrains: [],
}

const removeDuplicateTrains = (trains) => {
  return trains.filter(function (x, i, self) { 
    return (self.findIndex(function (y) {
      return (x.train_number === y.train_number)
    }) === i)
  })    
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_TRAIN_POSITION:
       // 在線位置が不明な列車と新横浜駅上り停車中の列車は除く
      var trains = action.payload.trains.filter(train => ((train.station_id || train.next_station_id) && !(train.station_id === 29 && train.direction === 'up'))).map(train =>{
        if(!train.train_kind_id) {
          // 種別がnullの場合は99999を割り当てる
          train.train_kind_id = 99999
        }
        return train
      })

      return {
        ...state,
        trains: trains,
        updatedAt: action.payload.updated_at,
      }
    case RECEIVE_JR_TRAIN_POSITION:
      if (action.payload.error && action.payload.error === 'U10002') { // 情報提供時間外
        return {
          ...state,
          jrLocationUpdatedAt: Date.now(),
        }
      }
      if (action.payload.uj_proxy_result !== 0 || action.payload.resultCode !== 'I00001') { alert('JR線のデータを読み込めませんでした。') }

      let jrTrains = extractJrTrains(action.payload)

      // 羽沢ー武蔵小杉間で列車が重複する場合に、上り新宿方面はJR線データを選択して、相鉄線データを削除する
      let sotetsuTrains = state.trains.filter(st => !jrTrains.some(jt => (jt.station_id || jt.next_station_id) && (st.station_id || st.next_station_id) && jt.direction === 'up' && st.direction === 'up' && jt.train_number === st.train_number))

      // 羽沢ー武蔵小杉間で列車が重複する場合に、下り海老名方面は相鉄線データを選択して、JR線データを削除する
      jrTrains = jrTrains.filter(jt => !sotetsuTrains.some(st => (st.station_id || st.next_station_id) && (jt.station_id || jt.next_station_id) && st.direction === 'down' && jt.direction === 'down' && st.train_number === jt.train_number))

      return {
        ...state,
        trains: merge(sotetsuTrains, jrTrains),
        jrLocationUpdatedAt: action.payload._ts,
      }
    case RECEIVE_TOKYU_TRAIN_POSITION:
      const mergedTokyuTrains = merge(state.trains, extractTokyuTrains(action.payload.trains))
      return {
        ...state,
        trains: removeDuplicateTrains(mergedTokyuTrains),
      }
    case RECEIVE_SHINYOKOHAMA_TRAIN_INFO:
      const mergedTrains = state.trains.map(train => {
        const apiTrain = action.payload.train
        if (apiTrain && `K${action.operationNumber}` === train.train_number) {
          train.train_number = apiTrain.train_number
          train.train_kind_id = apiTrain.train_kind_id
          train.destination_station_id = apiTrain.destination_station_id
        }
        return train
      })
      return {
        ...state,
        trains: mergedTrains
      }
    case RECEIVE_TRAIN_DETAIL:
      return {
        ...state,
        showingTrain: {
          hasIncidents: action.payload.has_incidents,
          apiTrain: action.payload.train,
          stopStations: action.payload.stop_stations,
          tidTrain: action.tidTrain,
        }
      }
    case RECEIVE_JR_TRAIN_DETAIL:
      if (action.payload.error && action.payload.error === 'U10002') { // 情報提供時間外
        return {
          ...state,
          jrDetailUpdatedAt: Date.now(),
        }  
      }

      let trainInfo = (action.payload.trainDetailInfo[0].trainInfo || []).find(train => train.trainNo === convertSotetsuToJr(action.tidTrain.train_number))
      
      if (trainInfo) {
        let jrStopStations = (trainInfo.organization[0].timeInfo || []).map(timeInfo => {
          let allStations = Object.values(MasterData.stations())
          let station = allStations.find(s => s.jreast_id === timeInfo.stopStation)

          if (!station) { return null } // 範囲外の駅を除外する

          return {
            will_stop: (timeInfo.pass === 1),
            supposed_arrival_time: timeInfo.planArrival,
            station_id: station.id,
            estimated_arrival_time_ja: timeInfo.prospectArrival,
            'estimated_arrival_time_zh-cn': timeInfo.prospectArrival,
            estimated_arrival_time_ko: timeInfo.prospectArrival,
            estimated_arrival_time_en: timeInfo.prospectArrival,
            name_ja: station.name_ja,
            name_en: station.name_en,
            name_ko: station.name_ko,
            'name_zh-cn': station['name_zh-cn'],
          }
        }).filter(v => v)

        return {
          ...state,
          showingTrain: {
            ...state.showingTrain,
            jrStopStations: jrStopStations,
          },
          jrDetailUpdatedAt: action.payload._ts,
        } 
      } else {
        return {
          ...state
        }
      }
    case CLOSE_TRAIN_MODAL:
      return {
        ...state,
        showingTrain: action.showingTrain
      }
    case CLOSE_TRANSFER_MODAL:
      return {
        ...state
      }
    case OPEN_TRAIN_SELECT_MODAL:
      return {
        ...state,
        selectingTrains: action.selectingTrains
      }
    case CLOSE_TRAIN_SELECT_MODAL:
      return {
        ...state
      }
    default:
      return state
  }
}

export default reducer
